module.exports = __webpack_public_path__ + "img/img_cont.b822ced6.jpg";